<template>
  <div>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-overlay>
    <v-overlay :value="getIsReportLoading" opacity="0.8">
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>
    <v-container fluid>
      <v-row class="time_period_wrap align-center">
        <span class="time_period_title pl-3">Time Period</span>

        <v-col cols="12" lg="4" class="d-flex align-center">
          <span class="date-display mr-2">{{ formatDate(this.datePeriod.fromDate) }}</span>
          <span class="date-separator mr-2">–</span>
          <span class="date-display">{{ formatDate(this.datePeriod.toDate) }}</span>
        </v-col>

        <v-spacer></v-spacer>
        <v-col cols="12" lg="2">
          <v-row align="center" class="nowrap">
            <v-text-field
                v-model="table.searchInReports"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                class="text-left pt-0 mt-0"
                @input="debounceSearch"
                dark
                single-line
                hide-details
            ></v-text-field>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <template>
      <v-data-table
          dense
          :headers="tableHeaders"
          :items="getDrillDownReports[drillDown.id] ? getDrillDownReports[drillDown.id].data : []"
          :server-items-length="getDrillDownReports[drillDown.id] ? getDrillDownReports[drillDown.id].count : 0"
          :loading="table.loading"
          :footer-props="{itemsPerPageOptions: table.pageOptions}"
          :disable-sort="true"

          fixed-header
          :class="`elevation-1 fixed-height report-table ${compact} items-size-${table.heightCounter}`"
          color="#7F98A5"
          @pagination="updateTablePagination"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :show-expand="isShowExpand"
          @click:row="handleExpand"
          :item-key="drillDown.type"
      >
        <!--header-->
        <template v-for="header in tableHeaders" :slot="`header.${header.value}`" slot-scope="{ header }">
          <data-filter :key="`filter-${drillDown.key}-${header.sortKey || header.value}`"
                       v-if="header.filterable === undefined || header.filterable"
                       :type="table.calculated.indexOf(header.sortKey || header.value) > -1 ? 'range' : 'items'"
                       :min="filtersData[header.value] && table.calculated.indexOf(header.value) > -1 ? +filtersData[header.value].find(i => i.key === 'min').value : 0"
                       :max="filtersData[header.value] && table.calculated.indexOf(header.value) > -1 ? +filtersData[header.value].find(i => i.key === 'max').value : 0"
                       :items="filtersData[header.sortKey || header.value] || []"
                       :entity="header.sortKey || header.value"
                       :values="getValues(header.sortKey || header.value)"
                       @search="searchFilter"
                       @apply="applyFilter"
                       @getLazyFilters = "getLazyFilters"
                       :isLazyLoad = "true"
          />
          <a v-if="(header.sortable === undefined || header.sortable) && header.text !== 'Referer'" @click="sortColumn(header.sortKey || header.value)">
            <div style="display: flex; align-items: center; gap: 4px;">
              {{ header.text }}
              <v-icon size="16" color="#7F98A5">
                {{ getSortIcon(header.sortKey || header.value) }}
              </v-icon>
              <span v-if="getSortIndex(header.sortKey || header.value) !== -1" style="font-size: 12px; color: #7F98A5;">
                {{ getSortIndex(header.sortKey || header.value) + 1 }}
              </span>
            </div>
          </a>
          <th v-else class="header_title">{{header.text}}</th>
        </template>
        <!--/header-->
        <!--body-->
        <template v-slot:body.prepend="{items, header, expand, isExpanded}">
          <tr class="compact">
            <td class="bkg-grey" v-if="isShowExpand">
              <v-icon @click="expandAll">
                mdi-arrow-collapse-vertical
              </v-icon>
            </td>
            <td v-for="header of tableHeaders" style="max-width: 20px;" class="text-center bkg-grey">
              <span v-if="header.value === 'drill_down'">TOTALS</span>
              <span v-else-if="headersWithoutTotals.includes(header.value)">
              -
            </span>
              <span v-else-if="['margin', 'sales_ratio', 'uvs_sales_ratio'].includes(header['value']) " class="d-block">
              {{totals[header.value] ? totals[header.value].toLocaleString("en-US") : 0}}%
              <span v-if="isShowExpand && expanded.length" class="font-weight-light d-block" >
                {{totalsComp[header.value] ? totalsComp[header.value].toLocaleString("en-US") : 0}}%
              </span>
              <span v-if="totals[header.value] && totalsComp[header.value] && isShowExpand && expanded.length" :class="(totals[header.value] >=totalsComp[header.value]) ? 'greenCol' : 'redCol'">
                {{(  (totals[header.value]/totalsComp[header.value]-1)*100  ).toFixed(2)}}%
              </span>
            </span>
              <span v-else-if="['uvs', 'clicks', 'conversions', 'total_paid', 'registrations', 'impressions', 'installations', 'sales'].includes(header['value'])" class="d-block">
              {{totals[header.value] ? totals[header.value].toLocaleString("en-US") : 0}}
              <span v-if="isShowExpand && expanded.length" class="font-weight-light d-block">
                {{totalsComp[header.value] ? totalsComp[header.value].toLocaleString("en-US") : 0}}
              </span>
              <span v-if="totals[header.value] && totalsComp[header.value] && isShowExpand && expanded.length" :class="(totals[header.value] >=totalsComp[header.value]) ? 'greenCol' : 'redCol'">
                {{(((totals[header.value]- totalsComp[header.value])/totalsComp[header.value])*100).toFixed(2)}}%
              </span>
            </span>
              <span v-else class="d-block">
              ${{totals[header.value] ? totals[header.value].toLocaleString("en-US") : 0}}
              <span v-if="isShowExpand && expanded.length" class="font-weight-light d-block">
                ${{totalsComp[header.value] ? totalsComp[header.value].toLocaleString("en-US") : 0}}
              </span>
              <span v-if="totals[header.value] && totalsComp[header.value] && isShowExpand && expanded.length" :class="(totals[header.value] >=totalsComp[header.value]) ? 'greenCol' : 'redCol'">
                {{(((totals[header.value]- totalsComp[header.value])/totalsComp[header.value])*100).toFixed(2)}}%
              </span>
            </span>
            </td>
          </tr>
        </template>
        <template v-slot:expanded-item="{ item, headers }" v-if="isShowExpand">
          <td v-for="header of headers" style="text-align: center; margin-bottom: 10px; white-space: nowrap" >
            <div v-if="!headersWithoutTotals.includes(header.value)">
              <div class="compData mt-3">
                {{
                  item.comparedData && item.comparedData[header.value]
                      ? item.comparedData[header.value].toLocaleString("en-US")
                      : (header.value === 'drill_down' ? `${timePeriodRangeComp.join(' - ')}` : '-')
                }}
              </div>
              <span v-if="item[header.value] && item.comparedData && item.comparedData[header.value]" :class="(item[header.value] >= item.comparedData[header.value]) ? 'greenCol' : 'redCol'">
              {{(((item[header.value] - item.comparedData[header.value])/item.comparedData[header.value])*100).toFixed(2)}}%
            </span>
              <span v-if="item[header.value] && !item.comparedData[header.value]" class="greenCol">100%</span>
              <span v-if="!item[header.value] && item.comparedData[header.value]" class="redCol">-100%</span>
            </div>
          </td>
        </template>
        <template v-for="header of table.headers" :slot="`item.${[header.value]}`" slot-scope="{item}">
          <template v-if="isEntityName(header.value)">
            <a class="entity-link" @click="showCard(item)">{{item[header.value]}}</a>
          </template>
          <template v-else>{{item[header.value]}}</template>
        </template>
        <template v-slot:item.drill_down="{item}">
          <template v-for="dDown in (user[0].can('see_referrer') ? table.drillDowns: table.drillDowns.filter(dd => dd.value !== 'referer'))">
            <v-tooltip bottom v-if="isShowDrillDown(dDown, item)" :key="dDown.type">
              <template v-slot:activator="{ on, attrs }">
              <span
                  @click="addTab({
                    type: dDown.type,
                    name: dDown.name,
                    entity: drillDown.type,
                    value: dDown.value,
                    tabName: item[drillDown.value],
                    id: item[drillDown.type]
                  })"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon size="16" class="drill_down_btn">{{dDown.icon}}</v-icon>
              </span>
              </template>
              <span>{{dDown.name}}</span>
            </v-tooltip>
          </template>
        </template>
        <template :slot="`item.${drillDown.type}`" slot-scope="{ item }">
          <template v-if="isEntityName(drillDown.value)" class="compact">
            <a class="entity-link" @click="showCard(item)">{{item[drillDown.value]}}</a>
          </template>
          <template v-else>{{item[drillDown.value]}}</template>
        </template>
        <template :slot="`item.${drillDown.type}`" slot-scope="{ item }">
          <span class="mr-1">
            {{ item[drillDown.type] }}
          </span>
        </template>
        <template :slot="`item.${drillDown.value}`" slot-scope="{ item }">
          {{ item[drillDown.value] }}
        </template>
        <template v-if="this.platform === 2" v-slot:item.lid="{ item }">
          <a v-if="item.lid" class="entity-link"  @click="showLIDCard(item)">
            {{ item.lid }}
          </a>
        </template>
        <template v-slot:item.referer="{item}">
        <span style="word-break: break-all">
          {{item.referer}}
        </span>
        </template>
        <template v-slot:item.uvs="{item}">
          {{item.uvs ? item.uvs.toLocaleString("en-US") : 0}}
        </template>
        <template v-slot:item.clicks="{item}">
          {{item.clicks ? item.clicks.toLocaleString("en-US") : 0}}
        </template>
        <template v-slot:item.impressions="{item}">
          {{item.impressions ? item.impressions.toLocaleString("en-US") : 0}}
        </template>
        <template v-slot:item.impressions="{item}">
          {{item.installations ? item.installations.toLocaleString("en-US") : 0}}
        </template>
        <template v-slot:item.impressions="{item}">
          {{item.sales ? item.sales.toLocaleString("en-US") : 0}}
        </template>
        <template v-slot:item.imp_tp="{item}">
          {{item.imp_tp ? item.imp_tp.toLocaleString("en-US") : 0}}%
        </template>
        <template v-slot:item.registrations="{item}">
          {{item.registrations ? item.registrations.toLocaleString("en-US") : 0}}
        </template>
        <template v-slot:item.reg_tp="{item}">
          {{item.reg_tp ? item.reg_tp.toLocaleString("en-US") : 0}}%
        </template>
        <template v-slot:item.conversions="{item}">
          {{item.conversions ? item.conversions.toLocaleString("en-US") : 0}}
        </template>
        <template v-slot:item.conv_tp="{item}">
          {{item.conv_tp ? item.conv_tp.toLocaleString("en-US") : 0}}%
        </template>
        <template v-slot:item.epc="{item}">
          ${{item.epc ? item.epc.toLocaleString("en-US") : 0}}
        </template>
        <template v-slot:item.avg_cost="{item}">
          ${{item.avg_cost ? item.avg_cost.toLocaleString("en-US") : 0}}
        </template>
        <template v-slot:item.cost="{item}">
          ${{item.cost ? item.cost.toLocaleString("en-US") : 0}}
        </template>
        <template v-slot:item.revenue="{item}">
          ${{item.revenue ? item.revenue.toLocaleString("en-US") : 0}}
        </template>
        <template v-slot:item.profit="{item}">
          ${{item.profit ? item.profit.toLocaleString("en-US") : 0}}
        </template>
        <template v-slot:item.margin="{item}">
          {{item.margin ? item.margin.toLocaleString("en-US") : 0}}%
        </template>
        <template v-slot:item.sales_ratio="{item}">
          {{item.sales_ratio ? item.sales_ratio.toLocaleString("en-US") : 0}}
        </template>
        <template v-slot:item.uvs_sales_ratio="{item}">
          {{item.uvs_sales_ratio ? item.uvs_sales_ratio.toLocaleString("en-US") : 0}}
        </template>
        <!--/body-->
      </v-data-table>
      <span class="updateData">
      Last updated: {{ value }} mins ago
      <v-btn icon @click="updateData"><v-icon color="#7F98A5">mdi-autorenew</v-icon></v-btn>
    </span>
      <div style="margin-top: -60px" class="flex right">
        <v-menu v-if="table.filters.length" offset-y top :close-on-content-click="false" v-model="filtersMenu" content-class="bg-white">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mx-2" icon v-bind="attrs" v-on="on">
              <v-icon color="secondary">mdi-filter-remove{{filtersMenu ? '' : '-outline'}}</v-icon>
            </v-btn>
          </template>
          <template>
            <v-card>
              <v-card-subtitle>Are you sure you want clear all filters?</v-card-subtitle>
              <v-card-actions>
                <v-btn text color="secondary" @click="filtersMenu = false">NO</v-btn>
                <v-spacer></v-spacer>
                <v-btn text color="error" @click="removeAllFilters">Yes</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-menu>
        <v-btn icon :disabled="table.heightCounter >= 63" @click="table.heightCounter += 3">
          <v-icon size="24" color="#7F98A5">mdi-magnify-plus-outline</v-icon>
        </v-btn>
        <v-btn icon :disabled="table.heightCounter <= 33" @click="table.heightCounter -= 3">
          <v-icon size="24"  color="#7F98A5">mdi-magnify-minus-outline</v-icon>
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters, mapState, mapActions} from "vuex"
import {getCookie, updateDate, formatDateRange} from "@/helpers"
import { debounce } from 'debounce'
import DataFilter from "@/components/common/DataFilter";
import reportsApi from "@/api/reports";
import advertiosersApi from "@/api/advertisers";
import offerApi from "@/api/offer";
import campaignApi from "@/api/campaigns";
import programsApi from "@/api/programs";
import lidApi from "@/api/lid";
import store from "../../store";
import pixelLog from "@/api/pixelLog";
import affiliates from "@/api/affiliates";
import timezones from "timezones-list";
import dateRange from "@/helpers/dateRange";


const columnMap = {
  'Offer': 'offer_id',
  'Campaign': 'campaign_id',
  'Program': 'program_id',
  'Sub_campaign': 'sub_campaign',
  'Geo': 'geo',
  'Day': 'day',
  'Hour': 'hour',
  'Isp': 'isp',
  'Affiliate': 'affiliate_id',
  'Os': 'os',
  'Device': 'device',
  'Vertical_name': 'vertical_name',
  'Advertiser': 'advertiser_id',
  'Affiliate_manager': 'affiliate_manager_id',
  'Advertiser_manager': 'advertiser_manager_id',
  'Referer': 'referer',
  'Tier': 'tier',
  'Highest_tier': 'highest_tier',
  'Custom': 'custom',
  'Img': 'img',
  'Kw': 'kw',
  'Cid': 'cid',
  'Lid': 'lid',
  'State': 'state',

};

export default {
  props: {
    timePeriodType : String,
    timePeriod : Object,
    timePeriodComp : Object,
    additionalColumns : Array,
    isActive: Boolean,
  },
  components: {
    DataFilter
  },
  data: vm=>({
    compact: '',
    selectedTimezone: 'UTC',
    timezones,
    hasMounted: false,
    platform:null,
    reportVersion:null,
    loading: false,
    expanded: [],
    singleExpand: true,
    leftValue: 765,
    isShowBlacklisted: false,
    onlyAggregatedStats: false,
    settings: {},
    table: {
      loading: false,
      searchInReports: '',
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 100, 200, 500],
      orderBy: 'clicks',
      sortColumnsAsc: false,
      userExplicitSort: false,
      heightCounter: 42,
      headers: [
        { text: 'Main', value: 'main', align: 'center', sortable: false, filterable: false},
        { text: 'Tags', value: 'tags', align: 'left', sortable: true, filterable: false },
        { text: 'UVs', value: 'uvs', align: 'center', sortable: true, filterable: false },
        { text: 'Clicks', value: 'clicks', align: 'center', sortable: true, filterable: false },
        // { text: 'Impressions', value: 'impressions', align: 'center' },
        // { text: 'Imp.TP', value: 'imp_tp', align: 'center' },
        { text: 'Registrations', value: 'registrations', align: 'center', sortable: true, filterable: false },
        { text: 'Installations', value: 'installations', align: 'center', sortable: true, filterable: false },
        { text: 'Sales', value: 'sales', align: 'center', sortable: true, filterable: false },
        { text: 'Reg.TP', value: 'reg_tp', align: 'center', sortable: true, filterable: false },
        { text: 'Conversions', value: 'conversions', align: 'center', sortable: true, filterable: false },
        { text: 'Total Paid', value: 'total_paid', align: 'center', sortable: true, filterable: false },
        // { text: 'Conv.TP', value: 'conv_tp', align: 'center' },
        { text: 'EPC', value: 'epc', align: 'center', sortable: true, filterable: false },
        { text: 'Avg. Cost', value: 'avg_cost', align: 'center', sortable: true, filterable: false },
        { text: 'Cost', value: 'cost', align: 'center', sortable: true, filterable: false },
        { text: 'Revenue', value: 'revenue', align: 'center', sortable: true, filterable: false },
        { text: 'Margin', value: 'margin', align: 'center', sortable: true, filterable: false },
        { text: 'Profit', value: 'profit', align: 'center', sortable: true, filterable: false },
        { text: 'Sales Ratio ‰', value: 'sales_ratio', align: 'center', sortable: true, filterable: false },
        { text: 'U. Sales Ratio ‰', value: 'uvs_sales_ratio', align: 'center', sortable: true, filterable: false },
      ],
      selectedFields: [],
      selectedFilters: [],
      selectedDropdowns: [],
      calculated: [
        'clicks', 'conversions', 'total_paid', 'epc', 'avg_cost', 'cost', 'revenue', 'margin', 'profit', 'uvs', 'sales_ratio', 'uvs_sales_ratio'
      ],
      drillDowns: [
        {type: 'offer_id', value: 'offer', name: 'Offer', icon: 'mdi-offer'},
        {type: 'program_id', value: 'program', name: 'Program', icon: 'mdi-open-in-app'},
        {type: 'campaign_id', value: 'campaign', name: 'Campaign', icon: 'mdi-bullhorn-outline'},
        {type: 'sub_campaign', value: 'sub_campaign', name: 'Sub campaign', icon: 'mdi-bullhorn'},
        {type: 'geo', value: 'geo', name: 'Geo', icon: 'mdi-earth'},
        {type: 'day', value: 'day', name: 'Day', icon: 'mdi-calendar-today'},
        {type: 'hour', value: 'hour', name: 'Hour', icon: 'mdi-hours-24'},
        {type: 'isp', value: 'isp', name: 'ISP', icon: 'mdi-spider-web'},
        {type: 'affiliate_id', value: 'affiliate', name: 'Affiliate', icon: 'mdi-account'},
        {type: 'os', value: 'os', name: 'Os', icon: 'mdi-microsoft-windows-classic'},
        {type: 'device', value: 'device', name: 'Device', icon: 'mdi-cellphone-link'},
        {type: 'vertical_name', value: 'vertical_name', name: 'Verticals', icon: 'mdi-align-vertical-bottom'},
        {type: 'advertiser_id', value: 'advertiser', name: 'Advertiser', icon: 'mdi-briefcase-account'},
        {type: 'affiliate_manager_id', value: 'affiliate_manager', name: 'AM', icon: 'mdi-account-tie'},
        {type: 'advertiser_manager_id', value: 'advertiser_manager', name: 'BD', icon: 'mdi-briefcase-account'},
        {type: 'referer', value: 'referer', name: 'Referrer', icon: 'mdi-arrow-expand-right', filetrable: false, sortable: false},
        {type: 'tier', value: 'tier', name: 'Tier', icon: 'mdi-medal', filetrable: false, sortable: false},
        {type: 'highest_tier', value: 'highest_tier', name: 'Highest Tier', icon: 'mdi-medal-outline', filetrable: false, sortable: false},
        {type: 'custom', value: 'custom', name: 'Custom', icon: 'mdi-tune', filetrable: false, sortable: false},
        {type: 'img', value: 'img', name: 'Image', icon: 'mdi-image', filetrable: false, sortable: false},
        {type: 'kw', value: 'kw', name: 'KeyWord', icon: 'mdi-format-title', filetrable: false, sortable: false},
        {type: 'cid', value: 'cid', name: 'Cid', icon: 'mdi-import', filetrable: false, sortable: false},
        {type: 'lid', value: 'lid', name: 'Lid', icon: 'mdi-export', filetrable: false, sortable: false},
        {type: 'state', value: 'state', name: 'state', icon: 'mdi-earth-box'},
      ],
      filters: [],
      lastSelectedFilter: ''
    },
    rangeMenu: false,
    rangeMenuComp: false,
    isCompClicked: false,
    timePeriodSelected: 'Today',
    timePeriodItems: [
      'Today',
      'Yesterday',
      'Week to date',
      'Month to date',
      'Year to day',
      'Last week',
      'Last month',
      'Last 7 days',
      'Custom'
    ],
    timePeriodRange: [new Date().toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)],
    timePeriodRangeComp: ['', ''],
    interval: {},
    value: 0,
    filtersData: {},
    filtersMenu: false,
    headersWithoutTotals: [
      'tags', 'offer_id', 'campaign_id', 'advertiser_id', 'affiliate_id', 'am', 'bd', 'geo', 'hour',
      'affiliate_manager_id', 'advertiser_manager_id', 'advertiser', 'affiliate', 'data-table-expand', 'isp',
      'day', 'os', 'device', 'sub_campaign', 'imp_tp', 'reg_tp', 'conv_tp',
      'affiliate_type','vertical_name', 'aff_id', 'referer', 'program_id', 'highest_tier', 'tier', 'custom','img','kw',
      'cid', 'lid', 'offer', 'campaign', 'program', 'advertiser', 'affiliate_manager', 'advertiser_manager', 'state',
    ],
    totals: {
      uvs: 0,
      clicks:0,
      impressions: 0,
      installations: 0,
      sales: 0,
      registrations: 0,
      conversions:0,
      total_paid:0,
      epc:0,
      revenue:0,
      margin:0,
      profit:0,
      cost: 0,
      avg_cost: 0,
      sales_ratio: 0,
      uvs_sales_ratio: 0,
    },
    totalsComp: {
      uvs: 0,
      clicks:0,
      impressions: 0,
      installations: 0,
      sales: 0,
      registrations: 0,
      conversions:0,
      total_paid:0,
      epc:0,
      revenue:0,
      margin:0,
      profit:0,
      cost: 0,
      avg_cost: 0,
      sales_ratio: 0,
      uvs_sales_ratio: 0,
    },
    copyTableHeaders: {},
    chartSelect: {},
    additionalKeys: {},
    filter: {},
    datePeriod: {},
    datePeriodComp: {},
    isDateCompareEnabled: false,
  }),

  beforeDestroy () {
    clearInterval(this.interval)
  },

  async mounted () {
    this.loadSavedTimezone();
    this.setDrillDowns();
    // this.reportVersion = window.location.pathname.includes('V2') ? 2 : 1;
    this.reportVersion = 2;
    // if (this.timePeriodType) {
    //   this.timePeriodSelected = this.timePeriodType;
    // }
    // if (this.timePeriod && this.timePeriod.from && this.timePeriod.to) {
    //   this.timePeriodRange = [this.timePeriod.from, this.timePeriod.to]
    // }
    //
    // if (this.timePeriod && this.timePeriod.from && !this.timePeriod.to && this.timePeriodType === 'Custom') {
    //   this.timePeriodRange = [this.timePeriod.from, this.timePeriod.from]
    // }
    //
    // this.isCompClicked = this.drillDown.breadCrumbs.length > 0 || !!(this.timePeriodComp && this.timePeriodComp.from && this.timePeriodComp.to);
    //
    if ( this.getAppliedSettings && this.getAppliedSettings.settings && this.getAppliedSettings.settings.compareDates) {
      this.timePeriodRangeComp = formatDateRange(this.getAppliedSettings.settings.compareDates);
    }
    if (this.timePeriodComp && this.timePeriodComp.from && this.timePeriodComp.to) {
      //this.timePeriodRangeComp = [this.timePeriodComp.from, this.timePeriodComp.to]
    }

    // if (this.drillDown.value === 'affiliate') {
    //   if (typeof this.additionalColumns === 'undefined') {
    //     this.additionalColumns = [{text: 'Affiliate Type', value: 'affiliate_type', sortKey: 'affiliate_type'}]
    //   }
    //   if (this.additionalColumns?.findIndex(f => f.value === 'affiliate_type') < 0) {
    //     this.additionalColumns.splice(3, 0, {text: 'Affiliate Type', value: 'affiliate_type', sortKey: 'affiliate_type'})
    //   }
    // }

    // if(this.additionalColumns && this.onlyAggregatedStats) {
    //   for(let i = 0; i < this.additionalColumns.length; i++) {
    //     if (this.table.headers.map(h => h.value).includes('advertiser_id') && this.additionalColumns[i].value === 'advertiser') {
    //       continue;
    //     }
    //     this.table.headers.splice(3+i, 0, this.additionalColumns[i]);
    //   }
    // }
    // remove fields from headers if user doesn't have permissions
    this.table.headers = this.table.headers.filter(
        h => !(['revenue', 'margin', 'profit'].includes(h.value) && !this.user[0].can('see_profit'))
    );

    this.table.headers = this.table.headers.filter(
        h => !(['total_paid'].includes(h.value)
            && !(this.user[0].can('edit_campaign_ping_rate') || this.user[0].can('see_campaign_ping_rate')))
    );

    console.log(` ********** this.table.headers ${JSON.stringify(this.table.headers)}` )
    console.log(` ********** this.table.selectedFields ${JSON.stringify(this.table.selectedFields)}`)
    this.platform = await affiliates.getPlatform()
    this.updateFiltersFromQuery();
    if (!this.table.selectedFields.length) {
      return;
    }
    await this.getGeneralData();
    this.interval = setInterval(() => {
      this.value += 3
    }, 180000)
    this.hasMounted = true;
  },

  watch: {
    timePeriodSelected () {
      if (!this.hasMounted) {
        return;
      }
      this.getGeneralData()
    },
    onlyAggregatedStats() {
      if (!this.hasMounted) {
        return;
      }
      // if (!this.onlyAggregatedStats && this.drillDown.value === 'offer') {
      //   this.table.headers = this.table.headers.filter(header => header.value !== 'advertiser')
      // } else if (this.drillDown.value === 'offer') {
      //   this.table.headers.splice(4, 0, {text: 'Advertiser', value: 'advertiser', sortKey: 'advertiser_id'})
      //   this.table.selectedFields.push('advertiser')
      // }
      this.getGeneralData()
    },
    isShowBlacklisted: function () {
      this.getGeneralData();
    },
    getExportCounter: function () {
      if (this.isActiveTab) {
        this.getGeneralData([], true);
      }

    },
    isActiveTab(newVal) {
      if (newVal && this.getDrillDownReports[this.drillDown.id]) {
        this.setExportReportData();
      }
    },
    getIsShowGraph: function () {
      this.getChartData();
    },
    getAppliedSettings() {
      this.setDrillDowns();
      this.updateFields();
    },
    getIsReportLoading: {
      handler(newValue) {
        console.log(newValue)
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    ...mapActions('settings', ['stopLoading']),
    setMode(mode) {
      if (mode === 'compact') {
        this.compact = 'compact';
        this.heightCounter = 24
      } else if (mode === 'comfortable') {
        this.compact = '';
        this.heightCounter = 42
      }
    },
    formatDate(timestamp) {
      const date = new Date(timestamp * 1000);
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC',
      });
    },
    async saveTimezone() {
      try {
        // Validate timezone using Intl API (works with Etc/GMT zones)
        try {
          Intl.DateTimeFormat(undefined, { timeZone: this.selectedTimezone });
        } catch (e) {
          this.selectedTimezone = 'UTC';
        }
        localStorage.setItem("selectedTimezone", this.selectedTimezone);
      } catch (error) {
        console.warn("Unable to access localStorage. Using default timezone 'UTC'.", error);
      }
      await this.getGeneralData();
    },
    loadSavedTimezone() {
      try {
        const savedTimezone = localStorage.getItem("selectedTimezone");
        if (savedTimezone) {
          // Validate timezone using Intl API (works with Etc/GMT zones)
          try {
            Intl.DateTimeFormat(undefined, { timeZone: savedTimezone });
            this.selectedTimezone = savedTimezone;
          } catch (e) {
            this.selectedTimezone = 'UTC';
          }
        } else {
          this.selectedTimezone = 'UTC';
        }
      } catch (error) {
        console.warn("Unable to access localStorage. Using default timezone 'UTC'.", error);
        this.selectedTimezone = 'UTC';
      }
    },
    expandAll() {
      if (!this.expanded.length) {
        this.expanded = this.getDrillDownReports[this.drillDown.id].data;
      } else {
        this.expanded = []
      }
    },
    isEntityName(item) {
      return ['advertiser', 'advertiser_id', 'affiliate', 'offer', 'campaign', 'program'].includes(item)
    },
    async showCard(item) {
      if (item.offer_id) {
        const offer = await offerApi.getOffer(item.offer_id);
        if (offer.type === 'aggregated'){
          window.open(`/advertisers/aggregatedOffer/${offer.id}`, '_blank');
        } else {
          window.open(`/advertisers/offerV2/${offer.id}`, '_blank');
        }
        return;
      }

      if (item.program_id) {
        const programData = await programsApi.getPrograms({
          limit: 1, page: 1, orderBy: 'id', orderDirectionAsc: true,
          filters: {id: item.program_id}
        });
        if (!programData || !programData.programs || !programData.programs.length) {
          return ;
        }
        const program = programData.programs[0];
        store.dispatch('cards/ADD', {
          type: 'program',
          title: `[${program.id}] - [${program.name}]`,
          key: `program-${program.id}`,
          data: program
        });
        return;
      }

      if (item.campaign_id) {
        const campaigns = await campaignApi.getCampaignsData({
          payload:{
            showInactiveCampaigns: true,
            filters: {id: item.campaign_id},
            orderBy: 'id',
            orderDirectionAsc: true,
            limit:1,
            page: 1
          }
        });
        if (!campaigns || !campaigns.data || !campaigns.data.length) {
          return
        }
        const campaign = campaigns.data[0];
        store.dispatch('cards/ADD', {
          type: 'campaign',
          title: `[${campaign.id}] - [${campaign.name}] : [${campaign.status}]`,
          key: `campaign-${campaign.id}`,
          data: campaign
        })

        return;
      }

      const advertiserData = await advertiosersApi.getAdvertisers({
        page:1,
        limit:1,
        orderBy: 'id',
        orderDirectionAsc: true,
        filters: {
          id: item.advertiser_id
        }
      });

      if (!advertiserData || !advertiserData.data || !advertiserData.data.length) {
        return;
      }

      const advertiser = advertiserData.data[0];

      if(item['advertiser'] || item['advertiser_id']) {
        store.dispatch('cards/ADD', {
          type: 'advertiser',
          title: advertiser.name,
          key: `advertiser-${advertiser.id}`,
          data: advertiser
        })
      } else if(item['affiliate']) {

        store.dispatch('cards/ADD', {
          type: 'affiliate',
          title: item.affiliate,
          key: `affiliate-${item.affiliate_id}`,
          data: item
        })
      }
    },
    async showLIDCard({ lid }) {
      try {
        console.log('lid', lid);
        this.loading = true;

        const [lidInfo, pixel, sale] = await Promise.all([
          lidApi.getLidInfo(lid),
          pixelLog.getPixelsLogs(lid),
          pixelLog.getSaleByLid(lid)
        ]);

        let lidInfoItem= {};
        if (lidInfo && lidInfo.length > 0) {
          lidInfoItem = lidInfo[0];

          if (pixel && pixel.length > 0) {
            lidInfoItem.pixel = pixel[0];
          }

          if (sale && sale.length > 0) {
            lidInfoItem.sale = sale[0];
          }

          lidInfoItem.s2sPings = await affiliates.getPings(lidInfoItem.affiliate_id);

          console.log('pixel', lidInfoItem.pixel);
          console.log('sale', lidInfoItem.sale);
          // console.log('s2sPings', lidInfoItem.s2sPings);
        } else {
          console.log('No LID information found');
        }

        console.log('lidInfoItem', lidInfoItem);
        await store.dispatch('cards/ADD', {
          type: 'lid',
          title: `[${lid}]`,
          key: `lid-${lid}`,
          data: lidInfoItem,
          customSize: {
            width: 717,
            height: 824,
            top: 700,
            left: this.leftValue,
          },
        });

      } catch (error) {
        console.error('Error in showLIDCard:', error);
      } finally {
        this.loading = false; // Set loading to false when the method finishes
      }
    },

    debounceSearch: debounce(function (value) {
      this.table.searchInReports = value;
      this.getGeneralData();
    }, 700),
    async getGeneralData (filter = [], withOutPagination = false) {
      // if (this.drillDown.value === 'affiliate') {
      //   if (typeof this.additionalColumns === 'undefined') {
      //     this.additionalColumns = []
      //     this.additionalColumns.push({text: 'Affiliate Type', value: 'affiliate_type', sortKey: 'affiliate_type'})
      //   }
      //   if (this.additionalColumns?.findIndex(f => f.value === 'affiliate_type') < 0) {
      //     this.additionalColumns.splice(3, 0, {text: 'Affiliate Type', value: 'affiliate_type', sortKey: 'affiliate_type'})
      //   }
      // }
      this.table.loading = true
      this.$emit('isChartDataFetched', false);
      filter.push(...this.table.filters);
      if (this.table.searchInReports.length > 0) {
        filter.push({
          field: 'search',
          value: [this.table.searchInReports],
        })
      }
      filter.push(...this.drillDown.breadCrumbs);
      if (!this.isShowBlacklisted) {
        filter.push({ field: 'affiliate_status', value: ['active', 'suspended', 'blocked', 'inactive'] });
      }
      //const datePeriod = updateDate({typeDate: this.timePeriodSelected, fromDate: this.timePeriodRange[0], toDate: this.timePeriodRange[1]});

      //console.log('datePeriod', datePeriod);

      let additionalKeys = this.additionalColumns ? this.additionalColumns.map(ac => ac.sortKey) : null;

      let select = [...this.table.selectedFields, 'unique_visits'];
      select.splice(select.indexOf('drill_down'), 1);
      // ToDo: It's a trick. Should resolve the infinity cycle.
      if (select && select.length && select.includes('affiliate_type')) {
        select.splice(select.indexOf('affiliate_type'), 1);
      }
      let chartSelect = JSON.parse(JSON.stringify(select));
      if(
          chartSelect.indexOf('margin') === -1
          && chartSelect.indexOf('revenue') === -1
          && chartSelect.indexOf('profit') === -1
      ) {
        chartSelect.push('margin', 'revenue', 'profit');
      }

      // if(this.additionalColumns) {
      //   for (let i = 0; i < select.length; i++) {
      //     const aColumn = this.additionalColumns.find(c => c.value === select[i]);
      //     if (aColumn) {
      //       select.push(aColumn.sortKey);
      //     }
      //   }
      // }
      // ToDo: It's a trick. Should resolve the infinity cycle.
      // if (additionalKeys && additionalKeys.indexOf('affiliate_type') >= 0) {
      //   select.push('affiliate_type');
      // }
      // if (!this.onlyAggregatedStats && additionalKeys && additionalKeys.length && additionalKeys.includes('advertiser_id')) {
      //   if (select && select.length && select.includes('advertiser')) {
      //     select.splice(select.indexOf('advertiser'), 1);
      //   }
      //   if (select && select.length && select.includes('advertiser_id')) {
      //     select.splice(select.indexOf('advertiser_id'), 1);
      //   }
      //   additionalKeys.splice(additionalKeys.indexOf('advertiser_id'), 1);
      // }
      // if (this.drillDown.value === 'affiliate' && !select.includes('affiliate_type')
      //     && (additionalKeys && !additionalKeys.includes('affiliate_type'))) {
      //   select.push('affiliate_type');
      //   additionalKeys.push('affiliate_type');
      // }
      //
      // const keysToDelete = [];
      // if (this.additionalColumns && this.additionalColumns.length > 0) {
      //   this.additionalColumns.forEach(col => {
      //     const result = chartSelect.indexOf(col.sortKey);
      //     if (result > 0) {
      //       keysToDelete.unshift(result)
      //     }
      //   })
      // }
      // keysToDelete.unshift(chartSelect.indexOf(this.drillDown.type));
      // if(chartSelect.indexOf('aff_id') >= 0) {
      //   keysToDelete.unshift(chartSelect.indexOf('aff_id'));
      // }

      // if (keysToDelete && keysToDelete.length > 0) {
      //   keysToDelete.forEach(index => {
      //     chartSelect.splice(index, 1)
      //   })
      // }

      if (!chartSelect.includes('day')) {
        chartSelect.push('day');
      }

      select = [...select.filter(s => !['advertiser', 'affiliate', 'offer', 'campaign', 'program'].includes(s))];

      if (!select.length) return;

      if (!this.datePeriod.fromDate || !this.datePeriod.toDate) {
        if (this.getAppliedSettings.settings) return;

        const todayDateUnix = Math.floor(Date.now() / 1000);
        this.datePeriod.fromDate = todayDateUnix;
        this.datePeriod.toDate = todayDateUnix;
      }

      const fromDateHuman = new Date(this.datePeriod.fromDate * 1000).toISOString().replace('T', ' ').split('.')[0];
      const toDateHuman = new Date(this.datePeriod.toDate * 1000).toISOString().replace('T', ' ').split('.')[0];

      console.log(`[DATE_PERIOD] ${fromDateHuman}  ${toDateHuman} time stamp  ${JSON.stringify(this.datePeriod)}`);

      this.isDateCompareEnabled = !!(this.datePeriodComp.fromDate && this.datePeriodComp.toDate);
      chartSelect = [...chartSelect.filter(
              s => !['advertiser', 'affiliate', 'offer', 'campaign', 'program', 'program_id', 'offer_id', 'campaign_id'].includes(s))
      ];

      console.log(`[ADDITIONAL_KEYS] ${JSON.stringify(additionalKeys)}  drillDown ${this.drillDown.type}`);
      if (this.table.selectedDropdowns.includes('campaign')) {
         additionalKeys.push('campaign_id');
      }

      const settings = {...this.getAppliedSettings.settings};

      if (!settings.drillDowns) {
        return;
      }

      const groupBy = settings.drillDowns.map(dd => columnMap[dd]).join(',');

      if (withOutPagination) {
        this.table.loading = false;
        this.$emit('isChartDataFetched', true);
        this.$store.dispatch('reports/saveDrillDownReportsWithoutPagination', {
          filter: filter,
          entity: this.drillDown.value,
          groupBy: groupBy,
          select: select,
          fromDate: this.datePeriod.fromDate,
          toDate: this.datePeriod.toDate,
          fromDateComp: this.datePeriodComp.fromDate,
          toDateComp: this.datePeriodComp.toDate,
          limit: 9999,
          page: 1,
          orderBy: this.table.userExplicitSort ? this.table.orderBy : '',
          orderDirectionAsc: this.table.sortColumnsAsc,
          drillDownType: this.drillDown.value,
          id: this.drillDown.id,
          onlyAggregatedStats: this.onlyAggregatedStats,
          isCompared: true,
          isChart: false,
          platform: this.reportVersion,
          timezone: this.selectedTimezone,
          isExporting: true,
          exportFields: this.getExportFields,
          breakdownBy: this.getBreakdownBy
        }).then();
        return;
      }

      this.chartSelect = chartSelect;
      this.additionalKeys = additionalKeys;
      if (this.table.selectedFilters){
        filter = [...filter, ...this.table.selectedFilters];
        console.log(`[FILTERS] ${JSON.stringify(filter)}`);
      }
      this.filter = filter;

      if (this.datePeriodComp.fromDate && this.datePeriodComp.toDate) {
        const fromDateHuman = new Date(this.datePeriodComp.fromDate * 1000).toISOString().replace('T', ' ').split('.')[0];
        const toDateHuman = new Date(this.datePeriodComp.toDate * 1000).toISOString().replace('T', ' ').split('.')[0];
        console.log(`[DATE_PERIOD_COMP] ${fromDateHuman}  ${toDateHuman}  timestamp  ${JSON.stringify(this.datePeriodComp)}`);
      }

      console.log(`[SELECTED_FILTERS] ${JSON.stringify(this.table.selectedFilters)}` );
      console.log(`[SELECTED_FIELDS] ${JSON.stringify(this.table.selectedFields)}` );
      console.log(`[SELECTED_DROP_DOWNS] ${JSON.stringify(this.table.selectedDropdowns)}` );

      const entity = this.table.selectedDropdowns.join(',');

      const sorting = this.getSortingParams();
      
      const orderBy = this.table.userExplicitSort ? (sorting.orderBy || this.table.orderBy) : '';

      const promises = [
        this.$store.dispatch('reports/saveDrillDownReports', {
          filter: filter,
          entity,
          groupBy: groupBy,
          select: select,
          fromDate: this.datePeriod.fromDate,
          toDate: this.datePeriod.toDate,
          fromDateComp: this.datePeriodComp.fromDate,
          toDateComp: this.datePeriodComp.toDate,
          limit: this.table.perPage,
          page: this.table.currentPage,
          orderBy: orderBy,
          orderDirectionAsc: false,
          orderDirs: sorting.orderDirectionAsc,
          drillDownType: this.drillDown.value,
          id: this.drillDown.id,
          onlyAggregatedStats: this.onlyAggregatedStats,
          isCompared: true,
          isChart: false,
          platform: this.reportVersion,
          timezone: this.selectedTimezone
        })
      ];

      if (this.getIsShowGraph) {
        await this.getChartData()
      }

      await Promise.all(promises);

      this.stopLoading();
      // if (this.getIsShowGraph) {
      //   this.$emit('isChartDataFetched', true);
      // }

      this.setExportReportData();


      // this.getFiltersData();
      //this.expanded = this.getDrillDownReports[this.drillDown.id].data;
      const options = this.buildOptions();

      if (!options.fromDate && !options.fromDate) {
        this.rangeMenu = true;
      }
      if (!options.fromDateComp && !options.toDateComp) {
        //this.rangeMenuComp = true;
      }
      this.$emit('updateTab', this.drillDown.key, options);
      this.table.loading = false;

      const totals = this.getDrillDownReports[this.drillDown.id].totals;
      const totalsComp = this.getDrillDownReports[this.drillDown.id].totalsComp;

      this.totals = {
        uvs: totals.total_uvs,
        clicks: totals.total_clicks,
        impressions: totals.total_impressions,
        installations: totals.total_installations,
        sales: totals.total_sales,
        registrations: totals.total_registrations,
        conversions: totals.total_conversions,
        total_paid: totals.total_total_paid,
        epc: totals.avg_epc,
        revenue: totals.total_revenue,
        margin: totals.total_margin,
        profit:totals.total_profit,
        cost: totals.total_cost,
        avg_cost: totals.total_avg_cost,
        sales_ratio: totals.total_sales_ratio,
        uvs_sales_ratio: totals.total_uvs_sales_ratio,
      };
      this.totalsComp = {
        uvs: totalsComp.total_uvs,
        clicks: totalsComp.total_clicks,
        impressions: totalsComp.total_impressions,
        installations: totalsComp.total_installations,
        sales: totalsComp.total_sales,
        registrations: totalsComp.total_registrations,
        conversions: totalsComp.total_conversions,
        total_paid: totalsComp.total_total_paid,
        epc: totalsComp.avg_epc,
        revenue: totalsComp.total_revenue,
        margin: totalsComp.total_margin,
        profit:totalsComp.total_profit,
        cost: totalsComp.total_cost,
        avg_cost: totalsComp.total_avg_cost,
        sales_ratio: totalsComp.total_sales_ratio,
        uvs_sales_ratio: totalsComp.total_uvs_sales_ratio,
      };

      this.$emit('updateTotals', this.totals);
    },
    async getFiltersData(customHeader = null) {
      if (this.drillDown.value === 'affiliate') {
        if (typeof this.additionalColumns === 'undefined') {
          this.additionalColumns = []
          this.additionalColumns.push({text: 'Affiliate Type', value: 'affiliate_type', sortKey: 'affiliate_type'})
        }
        if (this.additionalColumns?.findIndex(f => f.value === 'affiliate_type') < 0) {
          this.additionalColumns.splice(3, 0, {text: 'Affiliate Type', value: 'affiliate_type', sortKey: 'affiliate_type'})
        }
      }
      const datePeriod = updateDate({typeDate: this.timePeriodSelected, fromDate: this.timePeriodRange[0], toDate: this.timePeriodRange[1]});
      let additionalKeys = this.additionalColumns ? this.additionalColumns.map(ac => ac.sortKey) : null;
      if (!this.onlyAggregatedStats && additionalKeys && additionalKeys.length && additionalKeys.includes('advertiser_id')) {
        additionalKeys.splice(additionalKeys.indexOf('advertiser_id'), 1);
      }
      const mapper = {
        advertiser: 'advertiser_id',
        affiliate: 'affiliate_id'
      }
      this.table.headers.forEach(header => {
        if(customHeader && customHeader !== header.value && customHeader !== mapper[header.value]) {
          return;
        }
        if (this.drillDown.value === 'offer' && !this.onlyAggregatedStats && header.sortKey === 'advertiser_id') {
          return
        }
        if(header.filterable === undefined || header.filterable) {
          let filters = [...this.table.filters];
          if((header.sortKey || header.value) === this.table.lastSelectedFilter) {
            filters = filters.filter(f => f.field !== this.table.lastSelectedFilter);
          }
          if (this.drillDown.value === 'affiliate' && (additionalKeys && !additionalKeys.includes('affiliate_type'))) {
            additionalKeys.push('affiliate_type');
          }
          console.log(` ********** getFilter ${JSON.stringify(filters)}`);
          reportsApi.getFilter({
            filter: filters,
            name: header.sortKey || header.value,
            groupBy: additionalKeys ? `${this.drillDown.type},${additionalKeys.join(',')}` : this.drillDown.type,
            fromDate:  this.datePeriod.fromDate,
            toDate: this.datePeriod.toDate,
            onlyAggregatedStats: this.onlyAggregatedStats,
            drillDownType: this.drillDown.value,
            platform: this.reportVersion
          }).then(res => {
            this.filtersData = Object.assign({}, this.filtersData, res);
          });
        }
      });
    },
    async getLazyFilters(header){
      this.getFiltersData(header);
    },
    updateFiltersFromQuery() {
      const queryFilters = this.$route.query.filters && JSON.parse(this.$route.query.filters);
      if (queryFilters) {
        this.table.filters.push(queryFilters);
      }
    },

    buildOptions() {
      const options = {};
      options.periodType = this.timePeriodSelected;
      if (options.periodType === 'Custom') {
        options.fromDate = this.timePeriodRange[0];
        options.toDate = this.timePeriodRange[1];
        if (this.timePeriodRangeComp && this.timePeriodRangeComp[0] && this.timePeriodRangeComp[1]) {
          options.fromDateComp = this.timePeriodRangeComp[0];
          options.toDateComp = this.timePeriodRangeComp[1];
        }
      }
      return options;
    },

    getValues(entity) {
      const filter = this.table.filters.find(f => f.field === entity);
      return filter ? filter.value : undefined
    },
    camelToSnake(string) {
      return string.replace(/[\w]([A-Z])/g, function(m) {
        return m[0] + "_" + m[1];
      }).toLowerCase();
    },
    updateRange() {
      this.$refs.rangeMenu.save(this.timePeriodRange)
      this.getGeneralData()
    },
    updateRangeComp() {
      if (this.timePeriodRangeComp[0] && !this.timePeriodRangeComp[1]) {
        this.timePeriodRangeComp[1] = this.timePeriodRangeComp[0]
      }
      this.$refs.rangeMenuComp.save(this.timePeriodRangeComp)
      this.isCompClicked = true;
      this.getGeneralData()
    },
    updateFields() {
      this.getGeneralData();
    },
    updateTablePagination(params){
      if (
          this.table.currentPage === params.page &&
          this.table.perPage === params.itemsPerPage
      ) {
        return
      }
      this.table.currentPage = params.page
      this.table.perPage = params.itemsPerPage
      this.getGeneralData()
    },
    async sortColumn(column) {
      this.table.sortColumnsAsc = this.table.orderBy === column ? !this.table.sortColumnsAsc : true;
      this.table.orderBy = this.camelToSnake(column)
      this.table.userExplicitSort = true;
      await this.getGeneralData()
    },
    updateDataInFilters(data, modalName) {

    },
    isShowDrillDown(drillDown, item) {
      if (!this.table.selectedDropdowns.map(sd => sd.toLowerCase()).includes(drillDown.value.toLowerCase())) {
        return false;
      }
      if (this.drillDown.breadCrumbs.find(bc => bc.field === drillDown.type)) {
        return false;
      }
      return drillDown.type !== this.drillDown.type;
    },
    addTab(tab) {
      tab.breadCrumbs = [];
      this.drillDown.breadCrumbs.forEach(bc => {
        if(bc.field !== tab.entity && bc.value !== tab.id) {
          tab.breadCrumbs.push(bc)
        }
      })
      tab.key = this.drillDown.key || '';
      if (tab.id && tab.entity) {
        tab.breadCrumbs.push({field: tab.entity, value: tab.id, name: tab.tabName})
      }
      tab.key += `_${tab.id}_${tab.type}`;
      const options = {};
      options.periodType = this.timePeriodSelected;
      if(options.periodType === 'Custom') {
        options.fromDate = this.timePeriodRange[0];
        options.toDate = this.timePeriodRange[1];
        options.fromDateComp = this.timePeriodRangeComp[0];
        options.toDateComp = this.timePeriodRangeComp[1];
      }
      this.$emit('goDown', tab, options)
    },
    updateData() {
      this.getGeneralData()
      this.value = 0
    },
    // new filter methods
    searchFilter(search, entity) {
      const datePeriod = updateDate({typeDate: this.timePeriodSelected, fromDate: this.timePeriodRange[0], toDate: this.timePeriodRange[1]});
      console.log(` ************ searchFilter ${entity} ${search}`);
      reportsApi.getFilter({
        name: entity,
        groupBy: entity,
        fromDate:  this.datePeriod.fromDate,
        toDate: this.datePeriod.toDate,
        searchFilter: search,
        platform: this.reportVersion
      }).then(res => {
        this.filtersData = Object.assign({}, this.filtersData, res);
      });
    },
    async removeAllFilters() {
      this.table.filters = [];
      this.filtersMenu = false;
      await this.getGeneralData()
    },
    async applyFilter(data, entity) {
      const filterIndex = this.table.filters.findIndex(f => f.field === entity);
      if (filterIndex >= 0) {
        if (data && data.length) {
          this.table.filters.splice(filterIndex, 1, {field: entity, value: [...data]});
        } else {
          this.table.filters.splice(filterIndex, 1);
        }
        this.table.lastSelectedFilter = this.table.filters.length ? this.table.filters[this.table.filters.length - 1].field : '';
      } else {
        if (data && data.length) {
          this.table.lastSelectedFilter = entity;
          this.table.filters.push({field: entity, value: [...data]});
        } else {
          this.table.lastSelectedFilter = '';
        }
      }

      return await this.getGeneralData()
    },
    setExportReportData() {
      const items = this.getDrillDownReports[this.drillDown.id] ? this.getDrillDownReports[this.drillDown.id].data : []

      if (!items || !items.length) {
        return this.$store.dispatch('reports/setExportReportData', {}).then();
      }
      const propsToExclude = ['campaign_id', 'offer_id', 'affiliate_id', 'tags', 'comparedData',
        'advertiser_manager_id', 'affiliate_type', 'unique_visits', 'program_id', 'advertiser_id', 'affiliate_manager_id',

      ];
      const itemToSave = {...items[0]};

      for (let prop in itemToSave) {
        if (propsToExclude.includes(prop)) {
          delete itemToSave[prop]
        }
      }
      this.$store.dispatch('reports/setExportReportData', {...itemToSave, value: this.drillDown.value}).then();
    },
    closeComp() {
      this.rangeMenuComp = false;
      this.isCompClicked = false;
    },
    clearComp() {
      this.timePeriodRangeComp = ['', ''];
      const options = this.buildOptions();
      this.$emit('updateTab', this.drillDown.key, options);

      this.rangeMenuComp = false;
      this.isCompClicked = false;
    },
    async getChartData() {
      this.$emit('isChartDataFetched', false);
      await this.$store.dispatch('reports/saveChartReport', {
        filter: this.filter,
        entity: this.drillDown.value,
        groupBy: `day`,
        select: this.chartSelect,
        fromDate: this.datePeriod.fromDate,
        toDate: this.datePeriod.toDate,
        fromDateComp: this.datePeriodComp.fromDate,
        toDateComp: this.datePeriodComp.toDate,
        limit: 99999999,
        page: 1,
        orderBy: '',
        orderDirectionAsc: this.table.sortColumnsAsc,
        drillDownType: this.drillDown.value,
        id: this.drillDown.id,
        //onlyAggregatedStats: this.onlyAggregatedStats,
        onlyAggregatedStats: false,
        isCompared: this.isCompared,
        isChart: true,
        platform: this.reportVersion,
        timezone: this.selectedTimezone
      });
      this.$emit('isChartDataFetched', true);
      this.$emit('updateTotals', this.totals);
    },
    setDrillDowns() {
      const settings = JSON.parse(JSON.stringify(this.getAppliedSettings.settings));
      this.settings = JSON.parse(JSON.stringify(this.getAppliedSettings.settings));

      const dates = this.getDates;

      if (dates && dates.length && dates[0] && dates[1]) {
        this.datePeriod.fromDate = dates[0];
        this.datePeriod.toDate = dates[1];
        const fromDateHuman = new Date(this.datePeriod.fromDate * 1000).toISOString().replace('T', ' ').split('.')[0];
        const toDateHuman = new Date(this.datePeriod.toDate * 1000).toISOString().replace('T', ' ').split('.')[0];
        console.log(`[SET_SETTINGS_DATA] ${fromDateHuman}  ${toDateHuman} `);
      } else {
        // const today = dateRange.getToday();
        // this.datePeriod.fromDate = Math.round(today.start/1000);
        // this.datePeriod.toDate = Math.round(today.end/1000);
      }

      const compareDates = this.getCompareDates;
      if (compareDates?.length === 2 && compareDates[0] && compareDates[1]) {
        this.datePeriodComp.fromDate = compareDates[0];
        this.datePeriodComp.toDate = compareDates[1];
        const fromDateCompareHuman = new Date(this.datePeriodComp.fromDate * 1000).toISOString().replace('T', ' ').split('.')[0];
        const toDateCompareHuman = new Date(this.datePeriodComp.toDate * 1000).toISOString().replace('T', ' ').split('.')[0];
        console.log(`[SET_SETTINGS_COMPARE_DATA] ${fromDateCompareHuman} ${toDateCompareHuman} `);
      } else {
        this.datePeriodComp.fromDate = null;
        this.datePeriodComp.toDate = null;
      }

      this.isDateCompareEnabled = !!(settings && settings.compareDates && settings.compareDates.length);

      //const mainColumn = this.drillDown.type;

      if(settings && settings.columns) {
        settings.columns = [...settings.columns, ...settings.drillDowns];
      }

      if (settings && settings.drillDowns && settings.drillDowns.length) {
        this.table.selectedDropdowns = settings.drillDowns.map(i => i.toLowerCase());
      } else {
        this.table.selectedDropdowns = this.table.drillDowns.map(dd => dd.name);
      }

      if (settings && settings.columns && settings.columns.length) {
        this.table.selectedFields = [
          'drill_down',
          //mainColumn,
          ...settings.columns.map(column => columnMap[column] || column)
        ].filter((column, index, array) => array.indexOf(column) === index);

        console.log(`[SELECTED_FIELDS] ${JSON.stringify(this.table.selectedFields)}`);

      } else {
        this.table.selectedFields = [...this.table.headers.filter(h => h.text!=='Id').map(h => h.value)];
      }
      if (settings?.filters?.length) {
        this.table.selectedFilters = [...settings.filters];
      } else {
        this.table.selectedFilters = [];
      }
      console.log(`[SELECTED_FILTERS] ${JSON.stringify(this.table.selectedFilters)}` );
      if (typeof settings.isShowBlacklisted === 'boolean') {
        this.isShowBlacklisted = settings.isShowBlacklisted
      }

      if (typeof settings.onlyAggregatedStats === 'boolean') {
        this.onlyAggregatedStats = settings.onlyAggregatedStats
      }

      if (settings.mode) {
        this.setMode(settings.mode);
      }
      this.setDynamicFields();
    },

    setDynamicFields() {
      const columnsWithIds = ['Offer', 'Campaign', 'Affiliate', 'Program', 'Advertiser'];

      const tagsIndex = this.table.headers.findIndex(f => f.text === 'Tags');
      let insertIndex = tagsIndex !== -1 ? tagsIndex + 1 : 0;

      this.table.headers = this.table.headers.filter(header =>
              !this.drillDown.columns.some(col => col.idColumn === header.value || col.value === header.value)
      );

      this.drillDown.columns.forEach((column, index) => {
        if (columnsWithIds.includes(column.name)) {
          this.table.headers.splice(insertIndex, 0, {
            text: column.name + "Id",
            value: column.idColumn,
            align: 'center',
            sortable: false
          });
          insertIndex++;
        }

        this.table.headers.splice(insertIndex, 0, {
          text: column.name,
          value: column.value,
          align: 'center',
          filterable: false,
          sortable: true
        });
        insertIndex++;
      });

      const hasDrillDownHeader = this.table.headers.some(header => header.value === 'drill_down');

      if (!hasDrillDownHeader) {
        this.table.headers.unshift({
          text: 'Main',
          value: 'drill_down',
          align: 'center',
          filterable: false,
          sortable: false
        })
      }
    },
    getSortingParams() {
      if (!this.settings.sorting || Object.keys(this.settings.sorting).length === 0) {
        return { orderBy: '', orderDirectionAsc: true };
      }

      const columns = [];
      const directions = [];

      this.settings.sorting.forEach(entity => {
        if (!(columnMap[entity.field] || entity.field) || !entity.order) {
          return;
        }
        columns.push( (columnMap[entity.field] || entity.field));
        directions.push(entity.order);
      });


      return {
        orderBy: columns.join(','),
        orderDirectionAsc: directions.join(',')
      };
    },
    getSortIcon(key) {
      const sorting = this.getSortingParams();

      const orderByArray = sorting.orderBy.split(',');
      const directionArray = sorting.orderDirectionAsc.split(',');
      const index = orderByArray.indexOf(key);

      if (index !== -1) {
        const direction = directionArray[index];
        return direction === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down';
      }

      return 'mdi-arrow-up-down'; // Not sorted
    },
    getSortIndex(key) {
      const sorting = this.getSortingParams();
      const orderByArray = sorting.orderBy.split(',');
      return orderByArray.indexOf(key);
    },
    handleExpand(item) {
      if (!item) return;

      const itemId = item.advertiser_id;
      if (this.expanded.includes(itemId)) {
        this.expanded = [];
      } else {
        this.expanded = [itemId];
      }
    }

  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('reports', ['getExportCounter']),
    ...mapGetters('settings', ['getIsShowGraph', 'getAppliedSettings', 'getDates','getCompareDates', 'getIsReportLoading']),
    ...mapGetters('reports', ['getDrillDownReports', 'getMainFilterData', 'getExportFields', 'getBreakdownBy']),
    isCompared () {
      const result = (
          this.timePeriodSelected === 'Custom'
          && this.timePeriodRangeComp[0] !== ''
          && this.timePeriodRangeComp[1] !== ''
      );
      this.$emit('isCompared', result);
      return result
    },
    dateRangeText () {
      return this.timePeriodRange.join(' - ')
    },
    dateRangeTextComp () {
      if(this.isCompClicked && this.timePeriodRangeComp[0] && !this.timePeriodRangeComp[1]) {
        return this.timePeriodRangeComp[0]
      }
      if(!this.isCompClicked || !this.timePeriodRangeComp[0] || !this.timePeriodRangeComp[1]) {
        return 'Compare to'
      } else {
        return this.timePeriodRangeComp.join(' - ')
      }
    },
    isShowExpand() {
      return this.isDateCompareEnabled
    },
    tableHeaders() {
      const alwaysVisibleColumns = this.drillDown.columns.map(col => col.value);
      const alwaysVisibleIds = this.drillDown.columns.map(col => col.idColumn);

      return this.table.headers.filter(h =>
              this.table.selectedFields.includes(h.value) ||
              alwaysVisibleColumns.includes(h.value) ||
              alwaysVisibleIds.includes(h.value) ||
              h.text === 'Id'
      );
    },
    isActiveTab() {
      return this.isActive;
    },
    drillDown() {
      const drillDownKey = this.settings.drillDowns?.[0] || "Offer";
      return {
        key: drillDownKey.toLowerCase() + "s",
        name: drillDownKey,
        idColumn: drillDownKey.toLowerCase() + "_id",
        value: drillDownKey.toLowerCase(),
        type: columnMap[drillDownKey] || drillDownKey.toLowerCase(),
        entity: columnMap[drillDownKey] || drillDownKey.toLowerCase(),
        breadCrumbs: [],
        id: drillDownKey.toLowerCase() + "s",
        options: {
          periodType: this.settings.dateValues?.firstMenuValue || "Today",
        },
        columns: this.settings.drillDowns?.map(drillKey => ({
          key: drillKey.toLowerCase() + "s",
          name: drillKey,
          idColumn: drillKey.toLowerCase() + "_id",
          value: drillKey.toLowerCase(),
          type: columnMap[drillKey] || drillKey.toLowerCase(),
          entity: columnMap[drillKey] || drillKey.toLowerCase(),
        })) || [],
      };
    },
  }
}
</script>

<style scoped lang="sass">

::v-deep .compact
  .v-data-table__wrapper
    table
      tbody
        tr
          td
            color: darkgreen !important
            margin: 0 !important
            padding: 0 !important
            max-width: 100px !important
            white-space: nowrap !important
            overflow: hidden !important
            text-overflow: ellipsis !important

.header_title
  padding: 0 !important
  margin: 0 !important
  max-width: 150px !important
  padding-left: 40% !important

.timezone-menu
  display: flex
  align-items: center
  max-width: 500px
  margin-left: 0
  margin-right: auto

.timezone-label
  color: #FFFFFF
  font-size: 14px
  font-weight: 700
  margin-right: 10px

.timezone-select
  min-width: 200px
  max-width: 300px
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
  margin-top: -1px

.compData
  font-size: smaller
  color: var(--v-primary-base)
  display: block
.bkg-grey
  background-color: #cccccc
.greenCol
  color: #175a0c
.redCol
  color: brown
.report-table
  margin-top: 0px !important
  .v-data-table__wrapper
    height: 65.7vh
    overflow: auto
  .v-data-table-header
    th
      white-space: nowrap
.bg-white
  background-color: #fff
  z-index: 28 !important
.buttons-container
  margin-left: 10%
  margin-right: 10%

.time_period_title
  font-weight: bold

.date-display
  font-size: 1rem
  color: white

.date-separator
  font-size: 1.2rem
  font-weight: bold
  color: white

th
  display: flex !important
  align-items: center !important
  text-align: center !important

::v-deep .v-data-table-header th
  justify-content: center !important
  text-align: center !important

::v-deep .v-data-table-header th > a
  width: 100%
  display: flex
  justify-content: center


</style>
